import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';

interface Assistance {
    active: boolean;
    createdAt: any;
    endDate: any;
    startDate: any;
    updatedAt: any;
}

interface AssistanceId extends Assistance {
    id: string;
}

interface EmployeeAssistance {
    createdAt: any;
    daysOnTime: any;
    daysNotOnTime: any;
    daysNotAttend: any;
    daysNonWorking: any;
    employeeId: string;
    employeeDepartmentId: string;
    employeeName: string;
    updatedAt: any;
}

interface EmployeeAssistanceId extends EmployeeAssistance {
    id: string;
}

@Injectable()
export class AssistanceService {

    assistanceCollection: AngularFirestoreCollection<Assistance>;
    assistances: any;

    assistanceDocument: AngularFirestoreDocument<AssistanceId>;
    assistance: Observable<any>;

    employeePayrollCollection: any;
    employeesPayroll: any;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.ASSISTANCE_COLLECTION;
    }

    postAssistance(assistanceId: string, assistanceObject: any) {
        this.assistanceCollection = this.afs.collection(this.collection);

        return this.assistanceCollection.doc(assistanceId).set(assistanceObject).then(function() {
            // console.log('Document added with ID: ', docRef.id);
            return assistanceId;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
            return '';
        });
    }

    getAssistance(assistanceId: string) {
        this.assistanceDocument = this.afs.doc(this.collection + '/' + assistanceId);

        this.assistance = this.assistanceDocument.valueChanges();

        return this.assistance.map(object => object);
    }

    postAssistanceEmployeesAtomic(assistanceId: string, employees: any) {
        const batch = firebase.firestore().batch();

        this.employeePayrollCollection = firebase.firestore().collection(this.collection).doc(assistanceId).collection('employees');

        for (let item in employees) {
            const employeeRef = this.employeePayrollCollection.doc(employees[item].employeeId);

            batch.set(employeeRef, employees[item]);
        }

        return batch.commit();
    }

    getAssistanceEmployees(assistanceId: string) {
        this.assistanceDocument = this.afs.doc(this.collection + '/' + assistanceId);

        this.assistance = this.assistanceDocument.snapshotChanges().map(action => {
            const id$ = action.payload.id;

            const data = action.payload.data() as Assistance;

            return { id$, ...data };
        }).map(document => {
            this.employeePayrollCollection = this.afs.doc(this.collection + '/' + document.id$)
                              .collection('employees', ref => ref.orderBy('employeeName', 'asc'));

            const employeesRef: any = this.employeePayrollCollection.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const id$ = a.payload.doc.id;

                    const data = a.payload.doc.data() as EmployeeAssistance;

                    return { id$, ...data };
                });
            });

            return Observable.combineLatest(employeesRef, (employeesData) => {
                return {
                    employees: employeesData
                };
            }).map(data => {
                return {
                    employees: data.employees,
                    ...document
                };
            });
        }).mergeMap(object => Observable.combineLatest(object));

        return this.assistance;
    }

    getAssistances() {
        this.assistanceCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true)
                                    .orderBy('createdAt', 'asc'));

        this.assistances = this.assistanceCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Assistance;

                const endDate = data.endDate;
                const startDate = data.startDate;

                return { id$, endDate, startDate };
            });
        }).map(object => object);

        return this.assistances;
    }

    delAssistance(assistanceId: string) {
        this.assistanceDocument = this.afs.doc(this.collection + '/' + assistanceId);

        return this.assistanceDocument.delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

}
